import { render, staticRenderFns } from "./ContentView.vue?vue&type=template&id=e9a4bcb6&scoped=true"
import script from "./ContentView.vue?vue&type=script&lang=js"
export * from "./ContentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a4bcb6",
  null
  
)

export default component.exports